var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0805 3.99091L18.832 6.81818V11.0909C18.832 15.2 15.9578 18.9909 12.0805 20.1182C8.20314 18.9909 5.32891 15.2 5.32891 11.0909V6.81818L12.0805 3.99091ZM12.0805 2L3.3999 5.63636V11.0909C3.3999 16.1364 7.10361 20.8545 12.0805 22C17.0573 20.8545 20.761 16.1364 20.761 11.0909V5.63636L12.0805 2Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0752 9.66667C12.5815 9.66667 12.9919 10.0771 12.9919 10.5833V16.0833C12.9919 16.5896 12.5815 17 12.0752 17C11.5689 17 11.1585 16.5896 11.1585 16.0833V10.5833C11.1585 10.0771 11.5689 9.66667 12.0752 9.66667Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4502 7.375C13.4502 8.13439 12.8346 8.75 12.0752 8.75C11.3158 8.75 10.7002 8.13439 10.7002 7.375C10.7002 6.61561 11.3158 6 12.0752 6C12.8346 6 13.4502 6.61561 13.4502 7.375Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacyIcon.ee1988c2c1d91d1143b9608ad9e565a4.svg";
export { ForwardRef as ReactComponent };